import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { ContextButtonControl } from '../../WorkviewManager/PaperProcessModel/PaperProcessModal'
import WVMNotes from '../../Notes/WVMNotes'
import { Spinner } from '../../Loaders/Loaders'
import MiscFormSelectionList from './MiscFormSelectionList'
import MiscEntitySelection from './MiscEntitySelection'
import * as api from '../../../requests'
import { SUBROUTES } from '../../../App'

const MiscPaperProcessModal = ({ navToCorrespondence, closePaperModalUnlockItem, refreshView }) => {
  const history = useHistory()
  const { selectedRow } = useSelector((state) => state.workview2, shallowEqual)
  const [selectedModuleId, setSelectedModuleId] = useState(() => {
    const first = (SUBROUTES || [])
      .filter((r) => r.IsMiscRecordsType)
      .flatMap((r) => r.MiscRecordsModules || [])[0]
    return first?.MiscellaneousModuleId ?? null
  })
  const [showNoPaymentConfirm, setShowNoPaymentConfirm] = useState(false)
  const [loadingNoPaymentData, setLoadingNoPaymentData] = useState(false)
  const [hasSelectedRecord, setHasSelectedRecord] = useState(false)

  const allMiscModules = (SUBROUTES || [])
    .filter((r) => r.IsMiscRecordsType)
    .flatMap((r) => r.MiscRecordsModules || [])
  const modules = allMiscModules.map((m) => ({
    value: m.MiscellaneousModuleId,
    label: m.DisplayName,
  }))
  const selectedModule = allMiscModules.find((m) => m.MiscellaneousModuleId === selectedModuleId)

  useEffect(() => {
    setLoadingNoPaymentData(true)
    api.DOES_IMAGE_ENVELOPE_HAVE_PAYMENT(
      selectedRow.ImageEnvelopeId,
      (hasPayment) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(!hasPayment)
      },
      (err) => {
        setLoadingNoPaymentData(false)
        setShowNoPaymentConfirm(false)
        console.error(err.Message)
      }
    )
  }, [selectedRow.ImageEnvelopeId])

  useEffect(() => {
    const { SelectedFormDefinitionId, IsInitialFiling } = selectedRow
    if (IsInitialFiling && SelectedFormDefinitionId) {
      history.push(`/office/workview/miscellaneous/process/${SelectedFormDefinitionId}`)
    }
  }, [selectedRow.SelectedFormDefinitionId])

  return (
    <div className="wvm-modal">
      <div className="flex-column-wrapper paper-process-container">
       
        <div style={{ marginTop: '12px' }}>
          <SelectBox
            label="Module"
            value={selectedModuleId}
            onChange={(val) => setSelectedModuleId(Number(val))}
            options={modules}
            noPlaceholder
            disabled={hasSelectedRecord}
          />
        </div>
        {selectedModuleId !== null && selectedRow.IsInitialFiling && (
          <MiscFormSelectionList moduleId={selectedModuleId} icon={selectedModule?.FormsIcon} />
        )}
        {selectedModuleId !== null && !selectedRow.IsInitialFiling && (
          <MiscEntitySelection moduleId={selectedModuleId} onRecordSelected={(record) => setHasSelectedRecord(record !== null)} />
        )}
        {loadingNoPaymentData && <Spinner className="page-loader" themeColor="neutral" />}
      </div>
      {showNoPaymentConfirm && (
        <div className="no-payment-warning">No Payment found in Image Envelope.</div>
      )}
      <WVMNotes />
      <ContextButtonControl
        navToCorrespondence={navToCorrespondence}
        refreshView={refreshView}
        closePaperModalUnlockItem={closePaperModalUnlockItem}
      />
    </div>
  )
}

export default MiscPaperProcessModal
